import { mapUploadToAlbumImage } from '@pixum/image-service/lib/map-upload-to-album-image';
import { trackUploadImage } from 'utils';
import type { OnUploadComplete, Upload } from '@pixum/types';
import type { ImageStateUpdater } from '../../../../types/expressDesigner';

const EVENT_CATEGORY_CART = 'Warenkorb Step1';

export function onUploadComplete(updater: ImageStateUpdater): OnUploadComplete {
  return (upload: Upload) => {
    trackUploadImage(EVENT_CATEGORY_CART);
    const { id, uuid, width, height, rotatedWidth, rotatedHeight } = mapUploadToAlbumImage(upload);
    updater.updateImage({ id, uuid, width, height, rotatedWidth, rotatedHeight, isUpload: false });
  };
}
